// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2wXfs","colMaxWidth":"Table_colMaxWidth__W1jkX"};